import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import SiteLayout from '../components/SiteLayout';
import GumballIcon from '../components/GumballIcon';
import { publicApi } from '../api/client';
import { MEDIA_FILTERS, mediaDetailPath } from './media-shared';
import './media.css';

export default function MediaPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState(() => searchParams.get('category') || 'all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cat = searchParams.get('category') || 'all';
    setFilter(cat);
  }, [searchParams]);

  useEffect(() => {
    setLoading(true);
    const query = filter === 'all' ? undefined : filter;
    publicApi.getMedia(query)
      .then(setItems)
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [filter]);

  return (
    <SiteLayout pageClass="media-page">
      <div className="media-page-wrap">
        <header className="media-page-header">
          <div className="media-page-header-top">
            <a href="/" className="public-back-link media-back-compact">
              <GumballIcon name="home" size={16} />
            </a>
            <div>
              <h1 className="media-page-title">Media</h1>
              <p className="media-page-sub">Gumball Buddies gallery</p>
            </div>
          </div>
        </header>

        <div className="media-filters-sticky">
          <div className="filter-pills media-filter-pills" role="tablist" aria-label="Filter media">
            {MEDIA_FILTERS.map((f) => (
              <button
                key={f.key}
                type="button"
                role="tab"
                aria-selected={filter === f.key}
                className={`filter-pill ${filter === f.key ? 'active' : ''}`}
                onClick={() => {
                  setFilter(f.key);
                  if (f.key === 'all') {
                    setSearchParams({});
                  } else {
                    setSearchParams({ category: f.key });
                  }
                }}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>

        {loading && <p className="public-loading media-loading">Loading...</p>}

        {!loading && !items.length && (
          <div className="public-empty glass-card media-empty">
            <GumballIcon name="photo" size={40} />
            <h2>No media yet</h2>
            <p>Published artwork and videos will appear here.</p>
            <a href="/" className="cta-btn cta-secondary">Return Home</a>
          </div>
        )}

        {!loading && items.length > 0 && (
          <div className="media-ig-grid">
            {items.map((item) => (
              <Link
                key={item.id}
                to={mediaDetailPath(item, filter)}
                className="media-ig-tile"
                aria-label={`View ${item.title}`}
              >
                <div className="media-ig-tile-media">
                  {item.file_type === 'video' ? (
                    <>
                      <video src={item.file_url} muted playsInline preload="metadata" />
                      <span className="media-ig-play" aria-hidden="true">
                        <GumballIcon name="play" size={28} />
                      </span>
                    </>
                  ) : (
                    <img src={item.file_url} alt={item.title} loading="lazy" />
                  )}
                  <div className="media-ig-tile-overlay">
                    <span className={`category-tag category-${item.category}`}>{item.category}</span>
                    <h3>{item.title}</h3>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </SiteLayout>
  );
}
